export enum CategoryRequestEnum {
  PROFILE_CREATION = 'Creazione utenza',
  // ACCESS_PROBLEMS = "Problemi di accesso alla piattaforma",
  // B2C_USER_ASSIGNMENT = "Assegnazione utenza B2C",
  MODIFY_COMPANY_DATA_REQUEST = 'Richiesta modifica dati anagrafici impresa',
  MODIFY_DOSSIER_REQUEST = 'Richiesta modifica pratica',
  DOCUMENTATION_INFO_REQUEST = 'Richiesta informazioni documentazione (reperibilità e compilazione)',
  INTEGRATIVE_DOCUMENTATION_INFO_REQUEST = 'Richiesta informazioni su documentazione integrativa',
  PLATFORM_QUOTATION_SUPPORT = 'Supporto piattaforma preventivo',
  PROJECT_PLATFORM_SUPPORT = 'Supporto piattaforma pratiche',
  ASSESSMENT_COE_SUPPORT = "Supporto Assessment - COE",
  ALERT_NEW_MEASURES = 'Iscrizioni: Alert nuove misure agevolative',
  // INTERNAL_REQUEST = "Richieste interne",
  // CONSULTANT_REDIRECT = "Reindirizzamento ai canali di consulenza",
  VCF_ENGAGEMENT_LETTER = 'Verifica Crediti Bonus Edilizi – Engagement Letter',
  VCF_BILLING = 'Verifica Crediti Bonus Edilizi – Fatturazione',
  VCF_SUPPORT = 'Verifica Crediti Bonus Edilizi - Assistenza',
  DNSH_SUPPORT = 'Dichiarazione di conformità al principio DNSH',
  OTHER = 'Altro',
  UPGRADE_PLAN_PLUS = 'Upgrade Plan Plus',
  UPGRADE_PLAN_PREMIUM = 'Upgrade Plan Premium',
  VIDEOCONFERENCE_SUPPORT = 'Videoconferenza - Assistenza all\'accesso/ ri-pianificazione / altro',
}
